export default {
  myBalance: 'Il mio saldo',
  topUp: 'Ricarica',
  pay: 'Ricarica',
  repayment: 'Rimborso',
  balance: 'Saldo',
  usableBalance: 'Credito disponibile',
  inputBalance: "Inserisci l'importo",
  payBalance: 'Importo della ricarica',
  pecenter: 'Centro personale',
  lang: 'Lingua',
  cart: 'Carrello',
  recipientName: 'Destinatario',
  goRecharge: 'Ricarica ora',
  phone: 'Telefono',
  region: 'Regione',
  address: 'Indirizzo dettagliato',
  country: 'Paese o regione',
  province: 'Provincia',
  city: 'Città',
  postcode: 'Codice postale',
  action: 'Azione',
  mobileSettings: 'Impostazioni mobili',
  name: 'Nome',
  debt: 'DEBITO',
  add: 'Aggiungi un indirizzo di fatturazione per la carta di credito',
  addSuccess: 'Aggiunta riuscita',
  editSuccess: 'Modifica riuscita',
  editBtn: 'Modifica',
  edit: "Modifica l'indirizzo di fatturazione della carta di credito",
  del: 'Elimina',
  setDefault: 'Imposta come predefinito',
  defaultAddress: 'Indirizzo predefinito',
  setDefaultAddress: 'Imposta come indirizzo di spedizione predefinito',
  setSuccess: 'Impostazione riuscita',
  myAddress: 'I miei indirizzi',
  addAddress: 'Aggiungi un nuovo indirizzo',
  tradeTime: 'Ora della transazione',
  type: 'Tipo',
  incomeOrExpend: 'Entrata/Spesa',
  accountBalance: 'Saldo del conto',
  tradeNo: 'ID transazione',
  remark: 'Nota',
  tag: "Etichetta dell'indirizzo",
  addBillAddress: 'Aggiungi un indirizzo di fatturazione per la carta di credito',
  deleteBillAddress: "Elimina l'indirizzo di fatturazione",
  editBillAddress: "Modifica l'indirizzo di fatturazione",
  mergePay: 'Paga insieme',
  username: 'Nome utente',
  gender: 'Sesso',
  birthday: 'Data di nascita',
  avatar: 'Avatar',
  email: 'E-mail',
  site: 'Sito',
  myOrder: 'Ordine',
  sideBar: {
    myAccount: 'Il mio account',
    addressManage: 'Gestione indirizzi',
    myAsset: 'Portafoglio',
    billAddress: 'Indirizzo di fatturazione',
  },
  holder: {
    receiver: 'Destinatario',
    firstName: 'Nome',
    name: 'Cognome',
    region: 'Seleziona provincia/città/distretto/via',
    address:
      "Inserisci informazioni dettagliate sull'indirizzo, come via, numero civico, quartiere, numero di edificio, unità, ecc.",
    phone: 'Numero di telefono, il numero di cellulare deve essere inserito in un campo',
    input: 'inserisci',
    select: 'seleziona',
    tagHolder: 'Max. 120 caratteri (opzionale)',
    postCodeNoMatch: 'Il codice postale non corrisponde alla regione',
  },
  forget: {
    accountSafe: "Sicurezza dell'account",
    setPwd: 'Modifica password',
    inputBindEmail: 'Inserisci la tua e-mail collegata',
    inputVerifyCode: 'Inserisci il codice di verifica',
    inputPwd: 'Inserisci la nuova password',
  },
  accountInfo: {
    name: 'Account',
    selfInfo: 'Informazioni personali',
    cardBillAddress: 'Indirizzo di fatturazione della carta di credito',
    shipAddress: 'Indirizzo di spedizione',
    editUser: 'Modifica informazioni utente',
    inputCountry: 'Inserisci il tuo paese',
    editEmail: 'Modifica e-mail',
    editEmailHint:
      "(Consigliato solo quando l'e-mail è configurata in modo errato o presenta problemi)",
    editEmailHint1:
      'Per la sicurezza del tuo account, devi prima superare la verifica di sicurezza con "Codice di verifica e-mail + password di accesso"',
    editEmailHint2:
      'Per la sicurezza del tuo account, devi prima superare la verifica di sicurezza con "Codice di verifica e-mail"',
    currentEmail: 'E-mail attuale',
    clickVerify: 'Invia',
    reGet: 'Rinvia',
    nextStep: 'Passo successivo',
    notReGetCode: 'Rinvia dopo',
    logoutAccount: "Disconnetti l'account",
    emailNotEmpty: "L'e-mail non può essere vuota",
    logoutReason: 'Seleziona il motivo della disconnessione',
    latelyLogin: 'Ultimo accesso',
    moreRecord: 'Più registrazioni',
    visitRecord: 'Cronologia delle visite',
    visitTime: 'Ora della visita',
    ipAndDevice: 'Indirizzo IP e tipo di dispositivo',
    editLoginPwdHint:
      'Una password ad alta sicurezza può rendere il tuo account più sicuro. Si consiglia di modificare regolarmente la password e di impostarne una contenente numeri e lettere e di lunghezza superiore a 6 cifre.',
    editPayPwdHint:
      'La password richiesta quando si utilizza il saldo acbuy per pagare, imposta la password di pagamento per garantire la sicurezza del pagamento.',
    editVerifyEmailHint: 'Per proteggere la sicurezza del tuo account, verifica la tua e-mail.',
    payPwd: 'Password di pagamento',
    editPayPwd: 'Modifica password di pagamento',
    setPayPwd: 'Imposta password di pagamento',
    deleteAccount: 'Elimina account',
  },
  logoutReasonEnum: {
    0: 'Problemi di sicurezza/privacy',
    1: 'Servizio clienti scadente',
    2: 'Costi troppo elevati',
    3: 'Processo di acquisto complicato',
    4: 'Altre ragioni',
  },
  tradeTypeEnum: {
    0: 'Entrata',
    1: 'Spesa',
  },
  asset: {
    currentBalance: 'Saldo attuale',
    canWithdrawBalance: 'Importo disponibile per il prelievo',
    withdraw: 'Preleva',
    serialNo: 'N. di serie',
    amount: 'Importo',
    lossAmount: 'Importo speso',
    withdrawAmount: 'Importo del prelievo',
    inputWithdrawAmount: "Inserisci l'importo del prelievo",
    withdrawSuccess: "Ritiro inviato, l'elaborazione potrebbe richiedere fino a 72 ore.",
    transactionDate: 'Data della transazione',
    withdrawMethod: 'Metodo di prelievo',
    availableAmount: 'Importo disponibile',
    transactionNo: 'Numero di transazione',
    withdrawMsg:
      'Nota: Il prelievo del saldo verrà restituito tramite il canale originale. Il saldo verrà restituito sul conto di pagamento della transazione di prelievo in base alla cronologia delle spese.',
    transactionRecordsText: "Cronologia delle transazioni dell'importo disponibile",
    withdrawRecordText: 'Cronologia dei prelievi',
  },
  package: {
    packageInfo: 'Informazioni sul pacco',
    weightHaveUnit: 'Peso (g)',
    sizeHaveUnit: 'Dimensioni (cm)',
    freight: 'Spedizione',
    fee: 'Costo',
    transportMode: 'Modalità di spedizione',
    allPackage: 'Tutti i pacchi',
    myPackage: 'Pacchi',
  },
  packageStatusEnum: {
    0: 'Fondi in attesa',
    1: 'Non pagato',
    2: 'In transito',
    3: 'Completato',
    4: 'Annullato',
  },
  storage: {
    name: 'Magazzino',
    warehouseTime: 'Ora di ingresso in magazzino',
    submitTransport: 'Invia per la spedizione',
    lineCanUse: 'Pezzi disponibili',
    commonImg: 'Foto QC',
    customPhoto: 'Foto personalizzate',
    extendCare: 'Prolunga il periodo di stoccaggio',
    extendHint:
      'Il periodo di stoccaggio della tua merce in magazzino sarà prolungato di (30 * N) giorni. La nuova data di scadenza è',
    packMode: 'Metodo di imballaggio',
    retainPack: 'Imballaggio riservato',
    normalPack: 'Imballaggio predefinito',
    normalPackHint: 'Gli articoli verranno imballati con il loro imballaggio originale.',
    foldPack: 'Imballaggio piegato',
    foldPackHint:
      "Per i cartoni non fissati con colla, il magazzino li smonterà, li piegherà e li inserirà nel pacco dell'utente, il che può ridurre il volume del pacco in una certa misura. Ma ci sono anche casi di aumento del volume del pacco (quando ci sono meno merci, la lunghezza e la larghezza di piegatura del cartone possono aumentare).",
    discardPack: "Elimina l'imballaggio",
    discardPackHint:
      "Una volta eliminato l'imballaggio, il venditore potrebbe non accettare il servizio post-vendita e il pacco non potrà essere ritrovato/aggiunto di nuovo.",
    photoTemplate: 'Modello foto',
  },
  operate: 'Operazione',
  editAddress: 'Modifica indirizzo',
  underPaid: 'Non pagato',
  goTopay: 'Vai a pagare',
  viewRecord: 'Visualizza cronologia',
  faq: 'FAQ',
  question1: 'D: Il mio account verrà congelato se invio una richiesta di prelievo?',
  response1:
    "R: Dopo aver richiesto un prelievo, l'account congelerà l'importo della richiesta per garantire che l'importo del rimborso corrisponda all'importo richiesto.",
  question2:
    'D: "Completato" nella cronologia dei prelievi significa che il prelievo di fondi è andato a buon fine?',
  response2:
    'R: "Completato" significa che acbuy ha organizzato un rimborso, ma il tempo di arrivo sul tuo conto originale dipende dal tempo di elaborazione della piattaforma di terze parti.',
  question3: 'D: Il prelievo si basa sul tasso di cambio in tempo reale?',
  response3:
    'R: No, il tasso di cambio del prelievo si basa sul momento in cui i fondi sono stati ricaricati.',
  question4:
    "D: Come effettuare un prelievo quando il saldo del conto è diverso dall'importo del prelievo?",
  response4:
    "R: Quando il saldo del conto è superiore all'importo del prelievo, è possibile effettuare richieste in batch fino a quando il saldo del conto non è 0. Quando il saldo del conto è inferiore all'importo del prelievo, è possibile richiedere un prelievo singolo dell'importo totale.",
  stillRecharge: "Non abbastanza per pagare l'ordine, ricarica",
  amountDue: 'Importo dovuto',
  handingFee: 'Commissione di gestione',
  coupon: 'Coupon',
  couponPlaceholder: 'Riscatta coupon con codici coupon',
  off: 'SCONTO',
  minFee: 'Costo min.',
  freightText: 'Spedizione',
  limitTo: 'Limite a',
  shippingUsage: 'Utilizzo della spedizione',
  availableWarehouse: 'Magazzino disponibile',
  shippingFeeText: 'Spese di spedizione (escluse le spese di sdoganamento)',
  internationalParcel: 'Pacco internazionale',
  to: 'a',
  availableCoupons: 'Coupon disponibili',
  usedCoupons: 'Coupon utilizzati',
  expiredCoupons: 'Coupon scaduti',
  exchangeSuccess: 'Scambio riuscito!',
  myAffiliate: {
    name: 'Affiliato',
  },
  affiliateShare: 'Condividi',
  copyText: 'Copia',
  affiliateShareMsg:
    'I pagamenti di spedizione effettuati tramite link condivisi genereranno entrate di commissione per te.',
  businessType: 'Tipo di attività',
  payWay: 'Tipo di transazione',
  bzOrderNo: 'N. AC',
  amountDueTooltip:
    'A causa dei calcoli di conversione del tasso di cambio, potrebbe esserci una differenza di circa 0,01 o 0,02',
  balanceStatement: 'Estratto conto',
  billFlow: 'Fattura',
  affiliateFavorite: 'preferito',
  favourite: 'Preferito',
  canUseCountry: 'Paese disponibile',
  commonNo: 'N.',
  question5:
    "D: Quanto tempo ci vuole perché l'importo prelevato venga accreditato sulla mia carta?",
  response5:
    'R: I tempi di elaborazione dei prelievi possono variare a seconda del metodo di pagamento e della banca, in genere da 2 a 25 giorni. In circostanze normali, i prelievi verranno accreditati sul metodo di pagamento o di ricarica originale entro 48 ore. Se non ricevi il prelievo entro 48 ore, puoi contattare il servizio clienti per verificarne lo stato attuale.',
}
